import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class TokenGuard implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!!this.auth.getAccessToken()) {
            return true;
        }
        this.redirectToLogin();
        return false;
    }

    /**
     * Redirect user to login if does not exist token
     * @private
     */
    private redirectToLogin() {
        this.router.navigate(['/auth/signin']);
    }

}
